import React, { useState } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ConnectedRouter } from 'connected-react-router';
import App from '../components/app';
import { config } from '../config/axios';
import UIContext from '../contexts/UIContext';
import ImageIntentTouchStyle from '../components/v3/shared/protectedImage/ImageIntentTouchStyle';
import { isSaveBlockingEnabled } from '../utils/imageIntentReporter';

const AppWithRedirect = (props) => {
  config();
  return <App {...props} />;
};

export default function Root({ store, history, persistor, ...data }) {
  const [uiSettings] = useState({});

  return (
    <UIContext.Provider value={uiSettings}>
      {isSaveBlockingEnabled() && <ImageIntentTouchStyle />}
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ConnectedRouter history={history}>
            <AppWithRedirect {...data} history={history} />
          </ConnectedRouter>
        </PersistGate>
      </Provider>
    </UIContext.Provider>
  );
}
